import { StyledCard as BaseStyledCard } from "../styled";

export const StyledCard = BaseStyledCard;
